import React from 'react'
import {FormattedNumber} from 'react-intl'
import EmptyStar from '../../assets/icons/EmptyStar.svg'
import FullStar from '../../assets/icons/FullStar.svg'
import HalfStar from '../../assets/icons/HalfStar.svg'
import {maxStars} from '../../config/constants'
import {IStarsProps} from './Stars'
import styles from './CarStars.scss'

const CarStars = ({stars, total, starsOnly, hideTotal, onReviewLinkClick, starsStyle, ...props}: IStarsProps & {
  onReviewLinkClick: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void,
  starsStyle: string
}) => {
  stars = Math.max(0, Math.min(stars, maxStars))
  const fullStars = Math.floor(stars)
  const halfStars = (stars > fullStars + 0.2) ? 1 : 0
  const emptyStars = maxStars - fullStars - halfStars
  const starsPanel = <>
    {[...Array(fullStars).keys()].map(index => <FullStar key={index} className={['fa mb-1', styles.starColor].join(' ')}/>)}
    {[...Array(halfStars).keys()].map(index => <HalfStar key={index} className={['fa mb-1', styles.starColor].join(' ')}/>)}
    {[...Array(emptyStars).keys()].map(index => <EmptyStar key={index} className={['fa mb-1', styles.starColor].join(' ')}/>)}
  </>
  return <div {...props}>
    {starsPanel}
    {!starsOnly && <div onClick={onReviewLinkClick}
                        className={['d-inline-block ml-1 text-van', styles.stars, starsStyle].join(' ')}>
        <FormattedNumber value={stars} minimumFractionDigits={2} maximumFractionDigits={2}/>
        { !starsOnly && !hideTotal && <>&nbsp;({total})</> }
      </div>
    }
  </div>
}
CarStars.displayName = 'CarStars'
export default CarStars
